exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pinned[data-v-6e9ecf2a] {\n  position: fixed;\n  top: 63px;\n  background: var(--v-accent-darken2);\n  width: 100%;\n  z-index: 1;\n}", ""]);

// exports
